/*
 * Granu + Zapiet na gaveta do carrinho (Horizon)
 * - Monta o widget do Zapiet no #storePickupApp da gaveta quando ele aparece vazio
 *   (primeiro item num carrinho vazio, ou carrinho esvaziado e preenchido de novo).
 * - Obs.: a cada /cart/add ou /cart/change o próprio Zapiet trava o checkout e reinicia o widget
 *   (reavalia métodos/limites), então não recriamos o widget aqui.
 * - Devolve ao #cart-form a URL de checkout do Zapiet, que o morph do Horizon reseta para /cart.
 * - Reavalia a visibilidade da calculadora de frete depois de cada atualização.
 */
(function () {
  if (window.__granuZapietGaveta) return;
  window.__granuZapietGaveta = true;

  function app() {
    return document.getElementById('storePickupApp');
  }

  function zapietPronto() {
    return !!(window.Zapiet && typeof window.Zapiet.start === 'function' && window.ZapietCachedSettings);
  }

  function iniciarZapiet() {
    var el = app();
    if (!el || el.firstElementChild || !zapietPronto()) return;
    try {
      window.Zapiet.start(window.ZapietCachedSettings);
    } catch (e) {
      document.dispatchEvent(new CustomEvent('zapiet:start'));
    }
  }

  function restaurarAcaoDoForm() {
    var url = window.ZapietCheckoutUrl;
    var form = document.getElementById('cart-form');
    if (!url || !form) return;
    var liberado = false;
    try {
      liberado = !!(window.Zapiet && window.Zapiet.Widget && window.Zapiet.Widget.checkoutEnabled());
    } catch (e) {}
    if (liberado && form.getAttribute('action') !== url) form.setAttribute('action', url);
  }

  function atualizarCalculadora() {
    document.querySelectorAll('granu-calc-frete').forEach(function (c) {
      if (typeof c.atualizarVisibilidade === 'function') c.atualizarVisibilidade();
    });
  }

  /* Espera o Horizon terminar de redesenhar a gaveta (ele renderiza a seção de forma assíncrona). */
  function aposRedesenho(fn) {
    var tentativas = 0;
    var ultimoHtml = null;
    var timer = setInterval(function () {
      tentativas++;
      var alvo = document.querySelector('cart-drawer-component .cart-drawer__inner') || document.querySelector('.cart-page');
      var html = alvo ? alvo.innerHTML.length : 0;
      if ((html === ultimoHtml && tentativas > 2) || tentativas > 30) {
        clearInterval(timer);
        fn();
      }
      ultimoHtml = html;
    }, 150);
  }

  function aoAtualizarCarrinho() {
    aposRedesenho(function () {
      iniciarZapiet();
      restaurarAcaoDoForm();
      atualizarCalculadora();
      document.dispatchEvent(new CustomEvent('granu:zapiet-gaveta-atualizada'));
    });
  }

  document.addEventListener('cart:update', aoAtualizarCarrinho);

  /* Gaveta aberta: garante que o widget está montado (ex.: carrinho já tinha itens ao carregar a página). */
  document.addEventListener(
    'dialog:open',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('cart-drawer-component')) {
        iniciarZapiet();
        restaurarAcaoDoForm();
      }
    },
    true
  );

  function inicial() {
    var tentativas = 0;
    var timer = setInterval(function () {
      tentativas++;
      if (zapietPronto() || tentativas > 50) {
        clearInterval(timer);
        /* dá tempo para o próprio Zapiet montar primeiro; só age se o container continuar vazio */
        setTimeout(iniciarZapiet, 2000);
      }
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicial);
  else inicial();
})();
